var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.927 13.51c.043.03.084.064.122.101l3.57 3.44c.42.405.456 1.091.083 1.53l-.026.03a.985.985 0 0 1-1.468.049l-3.596-3.6a1.076 1.076 0 0 1-.107-.124 5.526 5.526 0 0 1-3.158.986 5.562 5.562 0 0 1-5.557-5.566 5.562 5.562 0 0 1 5.557-5.566 5.562 5.562 0 0 1 5.557 5.566 5.547 5.547 0 0 1-.977 3.153zm-4.58.92a4.071 4.071 0 0 0 4.068-4.074 4.071 4.071 0 0 0-4.068-4.075 4.071 4.071 0 0 0-4.068 4.075 4.071 4.071 0 0 0 4.068 4.074z"
  }))));
};
export default SvgSearch;